<template>
  <div class="con5">
    <div class="service">
      <div class="container">
        <div class="title">{{ title }}</div>
        <ul class="tabs-list">
          <li class="col-sm-3" v-for="(item, index) in list" :key="index">
            <a @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1">
              <span
                class="icon e_signature"
                v-show="hoverIndex === index"
                :style="{ backgroundImage: `url(${item.hoverImg})`, backgroundSize: item.imgSize }"
              ></span>
              <span
                class="icon e_signature"
                v-show="hoverIndex !== index"
                :style="{ backgroundImage: `url(${item.img})`, backgroundSize: item.imgSize }"
              ></span>
              <h2>{{ item.title }}</h2>
              <span class="intro">{{ item.desc }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
  },
  data() {
    return {
      hoverIndex: -1,
    }
  },
}
</script>

<style lang="less" scoped>
.service {
  background: #fff;
  padding-bottom: 90px;

  .title {
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 33px;
    padding: 50px 0;
  }

  .tabs-list {
    & > li a:hover {
      text-decoration: none;
    }

    li {
      text-align: center;
      float: left;
      width: 25%\9;
    }

    & > li .icon {
      display: block;
      width: 70px;
      height: 60px;
      background-repeat: no-repeat;
      margin: 0 auto 40px;
      text-decoration: none;
      background-position: center;
    }
  }

  .tabs-list h2 {
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    color: #333;
    line-height: 22px;
    font-weight: 700;
    transition: 0.3s all;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .tabs-list .intro {
    display: block;
    max-width: 220px;
    font-size: 14px;
    font-family: PingFangSC-Light;
    color: #666;
    line-height: 20px;
    margin: 0 auto;
    transition: 0.3s all;
  }

  .tabs-list li.active a h2,
  .tabs-list li.active a > span,
  .tabs-list > li a:hover h2,
  .tabs-list > li a:hover > span {
    color: #fa465a;
  }

  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    &::before,
    &::after {
      content: ' ';
      display: table;
    }

    &::after {
      clear: both;
    }
  }

  @media (min-width: 768px) {
    .tabs-list li {
      width: 25%;
    }
  }
  @media (min-width: 992px) {
    .container {
      width: 970px;
    }
  }

  @media (min-width: 768px) {
    .container {
      width: 750px;
    }
  }

  @media (min-width: 1200px) {
    .container {
      width: 1170px;
    }
  }
}
</style>
